import data from './attrs/data'
import methods from './attrs/methods'

import WorkProfiles from './components/WorkProfiles/Index'

export default {
    name: 'ProfessionalWorkProfiles',
    data,
    methods,
    components: {
        WorkProfiles
    }
}
